<template>
    <header class="header">
        <div :class="classes">
            <div class="container">
                <div class="headerItemsWrapper">
                    <div class="brandLinkWrapper">
                        <header-logo :class="brandLinkClasses"
                                     @mouseover.native="onHover"
                                     @mouseleave.native="onLeave"
                                     @click.native="closeMenu()">
                        </header-logo>
                    </div>

                    <div class="navbarTogglerWrapper">
                        <hamburger></hamburger>
                    </div>

                    <div class="navContainerWrapper">
                        <menu-panel></menu-panel>
                    </div>

                </div>

            </div>
        </div>
    </header>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import Hamburger from "./Hamburger";
    import MenuPanel from "./MenuPanel";

    export default {
        components: {MenuPanel, Hamburger},
        data() {
            return {
                active: false,
            }
        },
        computed: {
            classes() {
                return [
                    'containerWrapper',
                    {'containerWrapper-fixed': this.menuOpened},
                ]
            },
            brandLinkClasses() {
                return [
                    'navbar-brand brandLink',
                    {'halfHeartBeat animated secondAnimation': this.heartbeat},
                ]
            },
            ...mapState({
                menuOpened: state => state.ui.menuOpened,
                heartbeat: state => state.ui.heartbeat,
            }),

        },
        mounted() {
        },
        methods: {
            ...mapActions({
                closeMenu: 'ui/closeMenu',
            }),
            onHover() {
                if (this.active) {
                    return
                }

                this.active = true
                this.toggleHeartbeat()
            },

            onLeave() {
                this.active = false
            },
            ...mapActions({
                toggleHeartbeat: 'ui/toggleHeartbeat',
            })
        }
    }
</script>
